// FILE: components/cards/OrgCard.tsx
"use client";

interface OrgCardProps {
  emoji: string;
  name: string;
  examCount: number;
  pathCount?: number;
  onClick?: () => void;
}

export default function OrgCard({ emoji, name, examCount, pathCount = 0, onClick }: OrgCardProps) {
  return (
    <div
      onClick={onClick}
      className="bg-white border border-border rounded-2xl p-5 text-center cursor-pointer shadow-card hover:border-teal-500/40 hover:-translate-y-1 hover:shadow-card-md active:scale-[0.98] active:translate-y-0 transition-all duration-200 group"
    >
      <div className="w-14 h-14 rounded-2xl bg-teal-50 flex items-center justify-center text-2xl mx-auto mb-3 group-hover:scale-105 transition-transform">
        {emoji}
      </div>
      <div className="text-[13px] font-bold text-teal-800 mb-1.5 group-hover:text-orange-500 transition-colors leading-tight">
        {name}
      </div>
      <div className="text-[10px] text-muted-foreground font-medium leading-relaxed">
        <div>{pathCount} lộ trình</div>
        <div>{examCount} đề thi</div>
      </div>
    </div>
  );
}